import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FinancialYearSummary } from '@contracts/interfaces/financial-year-summary.interface';
import { FinancialYearAttachment } from '@contracts/interfaces/financial-year-summary.interface';
import { DateRange } from '@contracts/interfaces/transaction.interfaces';
import { ConnectionService } from './connection.service';

interface FinancialYearSummaryResponse {
  summary: FinancialYearSummary | null;
}

@Injectable({
  providedIn: 'root'
})
export class FinancialYearSummaryService {
  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService
  ) {}

  get(financialYear: string): Observable<FinancialYearSummary | null> {
    return this.http.post<FinancialYearSummaryResponse>(`${this.connectionService.address}/financial-year-summary-service/get`, { financialYear })
      .pipe(map(res => res.summary || null));
  }

  update(summary: FinancialYearSummary): Observable<FinancialYearSummary> {
    return this.http.post<FinancialYearSummaryResponse>(`${this.connectionService.address}/financial-year-summary-service/update`, { summary })
      .pipe(map(res => res.summary as FinancialYearSummary));
  }

  uploadReport(financialYear: string, range: DateRange, reportType: string, label: string, file: File, section = 'payroller', periodKey = ''): Observable<FinancialYearSummary> {
    const formData = new FormData();
    formData.append('financialYear', financialYear);
    formData.append('startDate', range.start.toISOString());
    formData.append('endDate', range.end.toISOString());
    formData.append('section', section);
    formData.append('periodKey', periodKey);
    formData.append('type', reportType);
    formData.append('label', label);
    formData.append('report', file);

    return this.http.post<FinancialYearSummaryResponse>(`${this.connectionService.address}/financial-year-summary-service/upload-report`, formData)
      .pipe(map(res => res.summary as FinancialYearSummary));
  }

  getReportURL(report: FinancialYearAttachment) {
    if (!report?.file) {
      return '';
    }

    if (report.file.storageKey && report.file.storageKey.length > 0) {
      return `${this.connectionService.address}/${report.file.path}/${report.file.storageKey}`;
    }

    return `${this.connectionService.address}/${report.file.path}/${report.file.filename}`;
  }
}
